export default __webpack_public_path__ + "static/media/user-2.1efedcf4.svg";